import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import GetAppIcon from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';

import LinearProgress from '~/components/LinearProgress';

import Dialog from '~/components/Dialog';
import ImageZoomViewer from '~/components/ImageZoomViewer';

import Request from '~/providers/Request';
import { URL } from '~/config/uri';

function ShowImage({ isOpen, file, handleClose }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [fileShow, setFileShow] = useState(null);

  const fileName = (file && file.name) || 'anexo';

  useEffect(() => {
    let objectUrl;

    async function showFile() {
      setLoading(true);
      const authorizationToken = await Request.getAuth();
      const response = await fetch(
        `${URL}/admin/medical_record_evolutions/${file.uuid}/file`,
        {
          method: 'GET',
          headers: new Headers({ Authorization: `Bearer ${authorizationToken}` }),
        }
      );
      const blob = await response.blob();
      objectUrl = window.URL.createObjectURL(blob);
      setFileShow(objectUrl);
      setLoading(false);
    }

    if (isOpen && file) {
      showFile();
    }

    return () => {
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [isOpen, file]);

  function handleDownload() {
    if (!fileShow) return;
    const a = document.createElement('a');
    a.href = fileShow;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  return (
    <Dialog
      icon={<AttachFileIcon />}
      isOpen={isOpen}
      handleClose={handleClose}
      title={fileName}
      headerActions={
        <IconButton
          color="inherit"
          onClick={handleDownload}
          disabled={!fileShow}
          aria-label="Download"
        >
          <GetAppIcon />
        </IconButton>
      }
    >
      <>
        <LinearProgress loading={loading} />

        {!loading && fileShow && (
          <ImageZoomViewer src={fileShow} alt={fileName} />
        )}
      </>
    </Dialog>
  );
}

ShowImage.propTypes = {
  id: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  file: PropTypes.object,
};

ShowImage.defaultProps = {
  id: null,
  file: null,
  isOpen: false,
};

export default ShowImage;
